import { Theme } from '@mui/material/styles';

export const header = (theme: Theme) => ({
    backgroundColor: 'white.main',
    boxShadow: theme.shadow,
    height:theme.headerHeight,
    justifyContent: 'center',
}) as const;

export const logo = (theme: Theme) => ({
    height: '45px',

    [theme.breakpoints.up(360)]: {
        height: '55px',
    },

    [theme.breakpoints.up('sm')]: {
        height: '70px !important',
    },
}) as const;
